import { z } from 'zod'

export const createLeaveRequestSchema = z
  .object({
    leaveType: z.string().min(1, 'Leave type is required'),
    startDate: z.string().min(1, 'Start date is required'),
    endDate: z.string().min(1, 'End date is required'),
    reason: z.string().optional(),
    durationType: z.enum(['full', 'half']).default('full'),
  })
  .refine((data) => data.endDate >= data.startDate, {
    message: 'End date must be on or after start date',
    path: ['endDate'],
  })

export type CreateLeaveRequestFormData = z.input<typeof createLeaveRequestSchema>

export const leaveDecisionSchema = z.object({
  note: z.string().optional(),
})

export type LeaveDecisionFormData = z.infer<typeof leaveDecisionSchema>

export const assignReplacementSchema = z.object({
  replacementUserId: z.string().min(1, 'Replacement user is required'),
})

export type AssignReplacementFormData = z.infer<typeof assignReplacementSchema>
